module.exports = __webpack_public_path__ + "static/flags/PT-22ce0d5130a168d226810e61c836a10b.gif";